var exports = {
  "k": "x804f0401--4e9465--container",
  "n": "x804f0401--4e9465--link",
};

module.exports = exports;
